$('.cair-carousel').slick({
    infinite: false,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="next"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 12.2903L4.5 7.57983L9 2.79807L6.78613 0.5L-3.09469e-07 7.57983L6.78612 14.5L9 12.2903Z" fill="#697378"/>\
    </svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="next">\
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">\
            <path fill-rule="evenodd" clip-rule="evenodd" d="M-5.15372e-07 2.70967L4.5 7.42017L-1.00452e-07 12.2019L2.21387 14.5L9 7.42017L2.21387 0.499999L-5.15372e-07 2.70967Z" fill="#697378"/>\
        </svg>\
    </button>',
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
    variableWidth: true,
    responsive: [
    // {
    //     breakpoint: 991,
    //     settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 1,
    //         centerMode: true,
    //         // variableWidth: true
    //     }
    // },
    {
        breakpoint: 991,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: false,
            initialSlide: 1
        }
    },
    {
        breakpoint: 575,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: false
        }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
});

$('#vmj-team-testimonials').slick({
    infinite: false,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="next"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 12.2903L4.5 7.57983L9 2.79807L6.78613 0.5L-3.09469e-07 7.57983L6.78612 14.5L9 12.2903Z" fill="#697378"/>\
    </svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="next">\
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">\
            <path fill-rule="evenodd" clip-rule="evenodd" d="M-5.15372e-07 2.70967L4.5 7.42017L-1.00452e-07 12.2019L2.21387 14.5L9 7.42017L2.21387 0.499999L-5.15372e-07 2.70967Z" fill="#697378"/>\
        </svg>\
    </button>',
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
    {
        breakpoint: 1199,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: false
        }
    },
    {
        breakpoint: 575,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "30px"
        }
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
});